import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { KnightVortexTutorialState } from './KnightTutorialAdapter.js';

type VState = KnightVortexTutorialState;

const PARTIAL = 'D3-E5,C4-E5,F2-D3,F2-E4,A3-B5';
const PARTIAL_GATED = `${PARTIAL}|E4>B5`;
const SOLVED = 'B2-C4,D1-B2,B0-D1,D3-E5,C4-E5,F2-D3,F2-E4,A3-B5,C2-A3,B0-C2|E4>B5';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { knight: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C0', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'D3', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { knight: PARTIAL },
                { knight: PARTIAL, gateMode: true },
                { knight: PARTIAL_GATED, gateMode: true },
                { knight: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle an unblocked pair active; a blocked pair stays amber
    {
        gameState: { knight: 'B2A0', gateMode: true, extraGates: [['A0', 'C0']] } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'D4', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Clear path before\ngate activation', cell: 'B1', anchor: 'center', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { knight: 'B2A0', gateMode: true, extraGates: [['A0', 'C0']] },
                { knight: 'B2A0|E4>B5', gateMode: true, extraGates: [['A0', 'C0']] },
            ] as VState[],
        },
    },

    // Scene 3: Knight teleportation
    {
        gameState: { knight: PARTIAL_GATED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'The knight enters\na gate...', cell: 'E3', anchor: 'far-left' },
            { type: 'text-label', text: '...exits from\nthe other side', cell: 'B5', anchor: 'far-right' },
            { type: 'pulse', cell: 'E4', color: COLORS.purple },
            { type: 'pulse', cell: 'B5', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { knight: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Gates count as\none knight move', cell: 'C0', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'E4', color: COLORS.purple },
            { type: 'pulse', cell: 'B5', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Knight tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches knight teleportation through Vortex gates.
 */
export const KNIGHT_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'knight-vortex',
    gridCode: '6/0-3:0C4,1F2,2A3,3D1',
    scenes,
    previewScene: 3,
};
